import React, { createContext, useState } from 'react'

export const ThemeContext = createContext()

export const ThemeProvider = ({children}) => {
  const [isLight, setIsLight] = useState(true)
  const switchTheme =() => {
    setIsLight(!isLight)
  }
  return(
    <ThemeContext.Provider value={
      {
        isLight,
        switchTheme
      }
    }>
      {children}
    </ThemeContext.Provider>
  )
}